import * as React from "react";

import { DateProviderProps } from "./DateProvider";

export const DateContext = React.createContext<DateProviderProps>({});

/** Use entire Date Context */
export const useDate = () => React.useContext<DateProviderProps>(DateContext);
